export const SEARCH_ALL_REGULATIONS = 'all'

const EMPTY = []

/**
 * Which of the post's regulations the composer's market search covers. A
 * Kambi outcome ID is the same in every regulation, and publishing checks
 * the attached outcomes on each regulation the post runs in, so searching
 * one regulation finds the market: the organization's default when the post
 * runs there, else its first. Searching more is opt-in (Rush Street posts run
 * in 19). A post with no regulations runs in every one.
 *
 * `scope` is the operator's choice: '' (the default), a regulation, or
 * SEARCH_ALL_REGULATIONS. A chosen regulation the post no longer runs in
 * falls back to the default. `options` is empty when there is nothing to
 * choose between.
 */
export function marketSearchScope({ targetOfferings = EMPTY, offeringIds = EMPTY, defaultOfferingId = '', scope = '', labelFor = String }) {
  const targeted = offeringIds.filter((offeringId) => targetOfferings.includes(offeringId))
  const searchable = targetOfferings.length ? (targeted.length ? targeted : targetOfferings) : offeringIds
  const fallback = searchable.includes(defaultOfferingId) ? defaultOfferingId : (searchable[0] || '')
  const value = scope === SEARCH_ALL_REGULATIONS || searchable.includes(scope) ? scope : fallback
  const all = value === SEARCH_ALL_REGULATIONS
  return {
    value,
    offerings: all ? searchable : (value ? [value] : EMPTY),
    all: all || searchable.length <= 1,
    options: searchable.length > 1
      ? [
        ...searchable.map((offeringId) => ({ value: offeringId, label: labelFor(offeringId) })),
        { value: SEARCH_ALL_REGULATIONS, label: `All ${searchable.length} regulations` },
      ]
      : EMPTY,
  }
}
